export const mental_mix = {
  data() {
    return {
      /** Наша пресловутая таблица */
      table: '',
      frml: 9,
      /** Минимальное слагаемое */
      minNum: '',
      /** Максимальное слагаемое */
      maxNum: '',
      /**
       *  Переменные для генерации по формуле
       *  */
      hasFormula: false,
      predefined: '',

      /** Минимальное и максимальное количество осей */
      minAxis: 0,
      maxAxis: 0,

      /** Текущий разряд */
      currentAxis: 0,

      /** Перенос числа по осям */
      transfer: 0,

      /** Предыдущее число для исключения дублей*/
      prev: '',

      /** Объект с данными осей */
      axis: "",
      /** Реакции */
      react_minus: [
        'muzyka_kostochek_-.mp4',
        'chtoby_stat_supergeroem_-.mp4',
        'davay_ya_seychas_zakroyu_glaza.mp4',
        'po-moemu_ya_chto-to_zabyl._ty_schitay_poka.mp4',
        'schitay_a_ne_vitay_v_oblakah.mp4',
        'tolko_vpered._ne_oglyadyvaysya_nazad.mp4',
        'pomogite.mp4',
        '01_dzhenias._idi_syuda-.mp4',
        '02_ne_boysya._ne_sem-.mp4',
        '03_te._kto_ne_razgadal_golovolomku-.mp4',
        '04_dostavay_abakus_i_treneruysya-.mp4',
        '05_kristally_nuzhno_zasluzhit-.mp4',
        '01_-_ne_vremya_grustit.mp4',
        '02_-_ne_vremya_veshat_nos.mp4',
        '03_-_ne_spi._drug.mp4',
        '04_-_budte_ostrymi.mp4',
      ],
      react_plus: [
        'priznavaysya_.mp4',
        'tolko_nikomu__.mp4',
        'aplodismenty_v_kruge.mp4',
        'aplodismenty.mp4',
        'vot_eto_skorost.mp4',
        'uau._ty_-_supergeroy.mp4',
        'hochu_posmotret_na_togo_supergeroya.mp4',
        'ey._podozhdi_menya._ya_za_toboy_ne_uspevayu.mp4',
        '01_ya_ne_veryu_svoim_glazam!_eto_fantastika!_+.mp4',
        '02_ya_rada_+.mp4',
        '03_yohou!_+.mp4',
        '04_vot_eto_skorost!_+.mp4',
        '05_molodec_drug!_+.mp4',
        '06_vy_porazili_menya!_+.mp4',
        '05_-_vasha_snorovka_vozhd.mp4',
        '06_-_molodcy_(logiya).mp4',
        '07_-_my_molodcy!_a_teper_mozhno_i_pospat.mp4',
        '08_-_ura._srabotalo.mp4',
        '09_-_ura.mp4',
        '10_-_ura!_na_ostrove.mp4',
        '11_-_ya_veryu_v_vas.mp4',
      ],
    }
  },
  props: {},
  methods: {
    /**
     * ФУНКЦИИ ГЕНЕРАТОРА
     * GENERATORS */

    /** Генерируем базовую таблицу для прямого счета. Глобальная table */
    generateBaseTable() {
      let table = new Array(10);
      for (let i = 0; i < 10; i++) table[i] = new Array(19);
      for (let x = 0; x < 10; x++) {
        for (let y = 0; y < 19; y++) {
          let j = (y - (9 - x));
          //if ((j >= 0) && (j < 10) && (y - 9 !== 0)) table[x][y] = 1;
          if ((j >= 0) && (j < 10)) table[x][y] = 1;
          else table[x][y] = 0;
        }
      }
      this.table = table;
      for (let x = -4; x < 5; x++) this.formula5(x, 0);
    },

    /** Генератор таблицы для формул на 5 */
    formula5(number, on) {
      //console.log('Заполняем формулу на 5: ', number, on);
      number = number * 1;
      on = on * 1;
      let table = this.table;
      if (number > 0) {
        for (let i = 5 - number; i < 5; i++) {
          table[i][9 + number] = on;
        }
      } else {
        for (let i = 5; i < 5 - number; i++) {
          table[i][9 + number] = on;
        }
      }
      this.table = table;
    },

    /** Генератор таблицы для формул на 10 */
    formula10(number, on) {
      number = number * 1;
      on = on * 1;
      //console.log('Заполняем формулу на 10: ', number, on);
      let table = this.table;
      if (number > 0) {
        for (let i = 10 - number; i < 10; i++) {
          if ((on !== 0) && (table[i][9 + number - 10] > 0)) {
            table[i][9 + number] = on + table[i][9 + number - 10];
          } else {
            table[i][9 + number] = 0;
          }
        }
      } else {
        for (let i = 0; i < 0 - number; i++) {
          if ((on !== 0) && (table[i][9 + number + 10] > 0)) {
            table[i][9 + number] = on + table[i][9 + number + 10];
          } else {
            table[i][9 + number] = 0;
          }
        }
      }
      this.table = table;
    },

    /** Вызываем заполнение таблиц по выбранным формулам. */
    checkFormula() {
      //console.log('CHECK FORMULA');
      let app = this;
      let formula = this.params.formula;
      let cifers = this.params.cifers;
      let cifers_dop = this.params.cifers_dop;
      if (formula != 0 && (cifers.length > 0 || cifers_dop.length > 0)) {
        //console.log('Формула есть', formula);
        this.hasFormula = true;
      } else {
        //console.log('Формулы нет', formula);
        this.hasFormula = false;
      }

      switch (formula) {
        case '0':
          break;
        case '5':
          cifers.forEach(function (i) {
            app.formula5(i, 5);
          });
          break;
        case '10':
          /* if (_.findIndex(cifers, (i) => i < 0) !== -1) {
             for (let x = 1; x < 10; x++) this.formula10(x, 1);
           }*/
          cifers.forEach(function (i) {
            app.formula10(i, 10);
            if (i < 0) {
              app.formula10(Math.abs(i), 1);
            }
          });
          break;

        case '10-5':
          cifers.forEach(function (i) {
            app.formula10(i, 10);
            if (i < 0) {
              app.formula10(Math.abs(i), 1);
            }
          });

          cifers_dop.forEach(function (i) {
            app.formula5(i, 5);
          });

          break;

        case '15':
          console.log('Формула комбинации');
          if (_.findIndex(cifers, (i) => i < 0) !== -1) {
            for (let x = 1; x < 10; x++) this.formula10(x, 1);
          }
          cifers.forEach(function (i) {
            //app.formula5(i, 6);
            console.log('Проверяем цифры', i);
            if (i < 0) {
              app.formula5((10 + i), 6);
              //console.log('i < 0', 10 + i);
              //app.formula10((10 + i), 9);
            } else {
              app.formula5((i - 10), 6);
              //console.log('i > 0', i - 10);
              //app.formula10((i - 10), 9);
            }
            app.formula10(i, 9);
            /*if (i < 0) {
              app.formula10(Math.abs(i), 1);
            }*/
          });
          break;
        case "*":
          for (let x = -4; x < 5; x++) this.formula5(x, 5);
          for (let x = -9; x < 10; x++) this.formula10(x, 10);
          break;
      }

      /*if (Array.isArray(this.params.formula)) {
        this.params.formula.forEach(function (e) {
          app.writeTable(e);
        })
      } else {
        this.writeTable(this.params.formula);
      }*/
    },

    /**
     *
     * ВЫЧИСЛЕНИЯ И РАНДОМАЙЗЕРЫ
     *
     * */

    /** Проверим выбранную формулу и какие числа можно брать.
     * Запишем массив чисел в глобальную переменную predefined */
    predefinedNums() {
      if (this.hasFormula) {
        let table = this.table;
        let arr = [];
        table.forEach(function (item, index) {
          let ind = item.findIndex(item => (item === 5 || item === 11 || item === 15));
          if (ind !== -1) {
            arr.push(index);
          }
        });
        this.predefined = arr;
      }
    },

    /** Вычисляем минимальное и максимальное значение
     * Записываем в глобальные переменные */
    checkRank() {
      let rank = this.params.rank.split('/');
      let min = +rank[0];
      let max = +rank[1];
      this.minNum = min;
      this.maxNum = max;
      this.minAxis = this.countRanks(min);
      this.maxAxis = this.countRanks(max);
    },

    /** Функция получения количества разрядов числа
     * Возвращаем количество разрядов*/
    countRanks(num) {
      if (num < 0) num = -num;
      return num.toString().length;
    },

    /** Функция выбора случайного номера из заданного диапазона.
     * Возвращаем число от - до + */
    generateRandom(min = 1, max) {
      //let min = +this.minNum;
      //let max = +this.maxNum;
      let num = this.randomInteger(min, max);
      let sign = this.randomInteger(0, 1);
      sign === 0 ? num = -num : '';
      return num;
    },


    /** Получаем число по выбранной формуле. Или false, если в таблице нет вариантов */
    getNumByFormula(sum) {
      //console.log('********** GET NUM BY FORMULA *********');
      //console.log('На входе число', sum);
      if (sum > 9) {
        sum = this.getDigitsFromNumber(sum)[1];
      }
      let table = this.table;
      let ind = table[sum].findIndex(item => (item === 5 || item === 11 || item === 15));
      // console.log('Число для формулы', (ind - 9));

      if (ind == -1) {
        return false;
      } else {
        return (ind - 9);
      }
    },

    /** ПРОВЕРКА ЧИСЛА ПО ТАБЛИЦЕ - число / промежуточная сумма.
     * Возвращаем или false или число */
    checkNumByTable(num, sum) {
      //console.log('CheckNumBYTable', num, sum);
      if (sum === false) return false;
      let ret = this.table[sum][num + 9];
      if (ret === 0) {
        return false;
      }
      return num;
    },

    /** Возвращаем число из таблицы
     * Можно дать -1 или 1, чтобы возвращались числа по конкретному знаку
     * */
    returnAllowedNumberByTable(sum, sign) {
      let table = this.table;
      let arr = _.map(table[sum], function (i, key) {
        if (i !== 0) return key - 9;
      });

      arr = _.filter(arr, function (i) {
        return typeof (i) !== "undefined";
      });

      if (sign) {
        arr = _.filter(arr, function (i) {
          if (sign >= 0) {
            return i >= 0;
          } else {
            return i <= 0;
          }
        });
      }
      //console.log('Таблица', arr);

      let num = _.sample(arr);
      //if (!num) num = 0;
      return num;
    },

    /** Получаем массив чисел из числа */
    getDigitsFromNumber(number) {
      let negative = false;
      let arr_num;
      if (Math.sign(number) === -1) negative = true;
      arr_num = Array.from(String(Math.abs(number)), Number);
      if (negative) arr_num = _.map(arr_num, function (i) {
        return -Math.abs(i);
      });

      return arr_num;
    },

    /** Получаем число из массива */
    getNumberFromArray(arr) {
      if (_.sum(arr) < 0) {
        arr = _.map(arr, function (i) {
          return Math.abs(i);
        });
        return -Math.abs(_.join(arr, ''));
      } else {
        return Math.abs(_.join(arr, ''));
      }
    },

    /** Вычисляем сумму разряда */
    getRankSumFromArray(arr, rank) {
      let minAxis = this.minAxis;
      let maxAxis = this.maxAxis;


      let app = this;
      let numbers = _.map(arr, function (i) {
        let digit = app.getDigitsFromNumber(i);

        if (minAxis !== maxAxis) {
          //console.log('Разница в осях есть');
          if (digit.length < maxAxis) {
            let nums = _.fill(Array(maxAxis - digit.length), 0);
            //console.log('Создаем массив с разницей в разрядах', nums);
            digit = _.union(nums, digit);
            //console.log('Склеиваем массивы', digit);
          }
        }

        return digit[rank] ? digit[rank] : 0;
      })
      return _.sum(numbers);
    },

    /** Последовательный запуск функций для запуска генератора */
    generatorBase() {
      //console.log('ГЕНЕРАТОР БАЗА СТАРТ');
      this.generateBaseTable();
      this.checkRank();
      this.checkFormula();
      this.predefinedNums();
      this.startGenerator();
      this.checkCifers();
      //console.log('ГЕНЕРАТОР БАЗА ФИНИШ');
    },

    checkCifers() {
      //console.log('CHECK CIFERS');
      let cifers = this.cifers;
      if (cifers.indexOf(false) !== -1) {
        //console.log('Перезапускаем генератор');
        this.generatorBase();
      }
      this.$root.wait = false;
    },

    startGenerator() {
      //console.log('Запускаем генератор');
      let app = this;
      let sum = 0;
      let cifers = [];

      /** Создаем пустой массив по количеству слагаемых
       * И делим его на чанки
       * */
      let terms = Math.abs(this.params.terms);
      let arr = new Array(terms);
      arr = _.chunk(arr, 3);

      /** Пробегаемся циклом по чанкам */
      arr = _.forEach(arr, function (chunk, step) {

        /** Элементов в чанке */
        let chunk_cifers = ''

        // Если есть формула и элементов в чанке больше 2, то запускаем генератор по формуле
        if (app.hasFormula && chunk.length > ((step > 0) ? 2 : 2)) {
          chunk_cifers = app.generateNumbersBySum(chunk.length, sum);
        } else {
          // Или просто генератор по количеству слагаемых
          chunk_cifers = app.generateNumbersByTerms(chunk, sum);
        }

        // В массив cifers добавляем полученный результат
        cifers = _.concat(cifers, chunk_cifers);

        // Сумма - сумма массива cifers
        sum = _.sum(cifers);

      });


      //console.log('ГЕНЕРАТОР ПОЛУЧИЛ МАССИВ', cifers);
      //console.log('СУММА', _.sum(cifers));

      this.cifers = cifers;
      this.sum = _.sum(cifers);

      //console.log('КОНЕЦ РАБОТЫ ГЕНЕРАТОРА');
      //this.finalSum(axis);
    },

    /** Генерируем числа по количеству слагаемых */
    generateNumbersByTerms(terms, sum) {
      // console.log('START GENERATE NUM BY TERMS');
      let app = this;

      // Мы получаем пустой массив чанка
      // Создаем локальную сумму
      let local_sum = sum;

      // Пробегаемся по пустому массиву
      _.forEach(terms, function (i, key) {
        // Генерируем число
        let number;
        if (app.params.formula == 0 && app.maxAxis === 1) {
          number = app.generateByLimit(local_sum);
          app.prev = number;
        } else {
          number = app.generateOneNumber(local_sum);
        }

        // Складываем нашу сумму с полученным числом
        local_sum = local_sum + number;

        // Массиву чанка присваиваем число
        terms[key] = number;
      });

      //console.log('FINISH GENERATE NUM BY TERMS - ВОЗВРАЩАЕМ', terms);
      // Возвращаем заполненный массив чанка
      return terms;
    },

    generateByLimit(sum, depth = 1) {
      if (typeof depth == 'number')
        depth++;
      else
        depth = 1;
      //console.log('Генератор по лимиту', sum);
      let to = +this.params.direct_to;
      //let num = this.generateRandom(1, to);
      let num = this.randomInteger(-to, to);
      //if ((this.checkNumByTable(num, sum) && (sum + num) <= to) && (num !== -sum) ) {
      let prev = this.prev;
      if ((this.checkNumByTable(num, sum) && (sum + num) <= to)) {
        //(prev !== -num)
        if((depth < 200) && (prev === -num)){
          //return num;
        } else {
          return num;
        }
      }

      //console.log('Перезапускаем', num, depth);
      return this.generateByLimit(sum, depth);

    },

    /** Генерируем числа под формулу */
    generateNumbersBySum(terms, sum, depth) {
      //console.log('GENERATE NUMBER BY SUM', terms, sum);
      if (typeof depth == 'number')
        depth++;
      else
        depth = 1;
      if (depth > 50) {
        console.log('***** ГЕНЕРАТОР НЕ СПРАВИЛСЯ *****');
        return false;
      }

      let breaks = false;
      let app = this;

      let maxAxis = this.maxAxis;
      let minAxis = this.minAxis;


      // Создаем переменную локальной суммы
      let local_sum = sum;

      // Массив полученных чисел
      let cifers = [];

      // Случайно определяем на каком разряде сработает формула
      let axis = this.randomInteger(1, this.maxAxis);

      // Получаем число суммы нужного разряда
      let local_sum_digit = this.getDigitsFromNumber(sum)[axis - 1];

      // Если нет такого разряда, то делаем его 0
      if (!local_sum_digit) local_sum_digit = 0;

      // Определяем за сколько шагов нужно получить нужное число
      let steps = terms - 1;

      // Получаем случайное число формулы, которое нам нужно получить в сумме
      let formula_num = _.sample(this.predefined);

      // Определяем число, которое нам нужно получить по формуле
      let num_by_formula = this.getNumByFormula(formula_num);

      if (formula_num + num_by_formula < 0) {
        formula_num = formula_num + 10;
      }

      //console.log(`Нам нужно сенерировать число ${formula_num} из суммы ${sum} за ${terms} слагаемых`);

      //console.log('Формула сработает на разряде', axis);
      // console.log('Нам нужно получить число', formula_num);

      // Задаем счетчик цикла
      let n = 1;

      /** Получаем массив чисел, подводящих к формуле */
      while (!((local_sum_digit + this.getRankSumFromArray(cifers, (axis - 1))) === formula_num)) {
        // Если количество чисел в массиве CIFERS больше или равно количеству шагов,
        // то обнуляем сумму и массив
        // console.log('Крутим генератор по сумме цифр', n);
        if (n > 500) {
          breaks = true;
          break;
        }
        if (cifers.length >= steps) {
          local_sum = sum;
          cifers = [];
        }

        // Генерируем число с промежуточной суммой
        let generated_number = app.generateOneNumber(local_sum);
        //console.log('Генерируем число', generated_number);
        //console.log('Промежуточная сумма', local_sum);

        // Если номер сгенерировался, то в массив cifers добавляем полученное число
        // и высчитываем промежуточную сумму
        if (generated_number) {

          /*if(minAxis !== maxAxis){
            let size_number = app.getDigitsFromNumber(generated_number);
            if(size_number < maxAxis){
              for(let i = 1; i <= (maxAxis - size_number);i++){

              }
            }
          }*/

          cifers.push(generated_number);
          local_sum = sum + _.sum(cifers);
        } else {
          console.log('ГЕНЕРАТОР. Число для суммы не найдено.');
        }

        n++;
      }

      /** Жестко применяем формулу */

        //console.log('Мы получили массив подводящий к формуле', cifers);
        // console.log('Теперь нам нужно применить формулу, чтобы получилось число', num_by_formula);

        // Генерируем число, отправляя в качестве параметров
        // локальную сумму, число которое нужно, разряд на котором нам нужно это число
      let fin_cif = app.generateOneNumber(local_sum, num_by_formula, (axis));

      // Если числа нет, запускаем генератор по сумме заново
      if (!fin_cif || breaks) {
        //console.log('ГЕНЕРАТОР. Число для формулы не найдено, перезапускаем');
        return this.generateNumbersBySum(terms, sum, depth);
      }

      // Добавляем в массив число с цифрой формулы
      cifers.push(fin_cif);

      // Если у нас количество цифр меньше чем количество слагаемых чанка
      // Добавляем числа через генератор
      while (cifers.length !== terms) {
        let local_sum = (sum + _.sum(cifers));
        cifers.push(this.generateOneNumber(local_sum));
      }

      // Возвращаем массив чисел
      //console.log('Финальный массив чисел', cifers);
      return cifers;

    },


    /** Генерируем одно число и проверяем сумму по таблице */
    generateOneNumber(sum, f_num = false, f_axis = false, depth) {

      // console.log('GENERATE ONE NUMBER', sum);
      // console.log('ONE NUMBER. Промежуточная сумма ' + sum + ', число ' + f_num + ' на разряде ' + f_axis);
      // Создаем переменную глубины для регулирования рекурсии
      if (typeof depth == 'number')
        depth++;
      else
        depth = 1;

      // Получаем промежуточную сумму, число и номер разряда на котором нам нужно получить число
      // console.log('GENERATE ONE NUMBER', sum, f_num, f_axis);

      let app = this;
      let breaks = false;

      let transfer = 0;

      // Массив, куда запишем все разряды числа
      let final_number = [];

      // Знак числа - изначально false
      let sign = false;
      let maxAxis = this.maxAxis;
      let minAxis = this.minAxis;

      // Вычисляем максимальное число - максимальное количество осей + 1
      // Разворачиваем массив
      let max_fin = _.reverse(new Array(maxAxis + 1));

      // Получаем массив разрядов из суммы
      // Разворачиваем массив
      let local_sum = _.reverse(this.getDigitsFromNumber(sum));

      // Определяем количество разрядов числа
      let r = this.randomInteger(minAxis, maxAxis);

      // console.log(`Число будет из ${r} разрядов`);

      // console.log('Запускаем цикл по осям и генерируем число под нужное кол-во разрядов');
      _.forEach(max_fin, function (i, key) {
        // Вычисляем локальную сумму текущего разряда
        let l_sum = (local_sum[key] ? local_sum[key] : 0) + transfer;

        // console.log(`Трансфер ${transfer}, Сумма ${l_sum}, Шаг ${key}`);
        // Задаем переменную для получаемого разряда
        let num = '';

        // Если текущий разряд меньше или равен максимальному
        // То генерируем число по таблице
        if ((key + 1) <= r) {
          num = app.returnAllowedNumberByTable((l_sum), sign);
          // console.log('Число', num);
          // Если число не определено
          // Или разряд последний и число равно 0
          // или число равно 0, а глубина рекурсии меньше 200
          //console.log('У нас получилось число', num);
          // || ((key === r - 1) && num === 0 && depth < 200)
          if (typeof (num) == "undefined" || (((key + 1) === r) && num === 0 && depth < 300) || ((key === r - 1) && num === 0 && depth > 200)) {
            // console.log('ВКЛЮЧАЕМ БРЕЙК, Т.К. ПОЛУЧЕННЫЙ НОМЕР', num);
            //console.log('И оно нам не подходит');
            // console.log('Останавливаем цикл с числом', num);
            // Останавливаем цикл
            breaks = true;
            return false;
          }

        } else {
          // Если разряд числа дополнительный (максимальный), то возвращаем 0
          num = 0;
        }

        // Мы должны дать в генератор знак минус/плюс
        if (!sign && num !== 0) {
          sign = num;
        }


        if ((l_sum + num) > 9) {
          //console.log('Ебашим на 10');
          //console.log('Сумма больше 9');
          //console.log(`Получили число ${num} при промежуточной сумме ${l_sum}`);
          transfer = 1;
        } else if ((l_sum + num) < 0) {
          transfer = -1;
        } else {
          transfer = 0;
        }


        // Записываем полученное число в массив
        // console.log(`Записываем число ${num} плюс трансфер ${transfer}`, (num + transfer));
        final_number.push(num);

      });
      // В массив Cifers помещаем массив полученного числа и разворачиваем его назад
      // console.log('Final before', final_number);
      let cifers = _.reverse(final_number);
      // console.log('Массив полученных чисел', cifers);

      if (f_num && (cifers[f_axis] !== f_num)) {
        // console.log('ВКЛЮЧАЕМ БРЕЙК, Т.К. НЕ СОВПАДАЕТ НУЖНЫЙ НОМЕР НА ОСИ');
        breaks = true;
      }

      //console.log('DEPTH', depth);
      final_number = this.getNumberFromArray(cifers);

      if ((sum + final_number) < 0) {
        breaks = true;
      }


      if (!breaks) {

        // Получаем число из нашего массива цифр
        return final_number;
        /*if (f_num) {
          console.log('Нам нужно получить число на оси', f_num, f_axis, cifers[f_axis], cifers);
        }*/

      } else if (depth > 1500) {
        //console.log('ОСТАНАВЛИВАЕМ, Т.К. ГЛУБИНА', depth);
        return false;
      } else {
        //console.log('ONE NUMBER. Промежуточная сумма ' + sum + ', число ' + f_num + ' на разряде ' + f_axis);
        //console.log('Перегенерируем. Получили номер', final_number);
        //console.log('Глубина', depth);
        return this.generateOneNumber(sum, f_num, f_axis, depth);
      }


      //console.log('CIFERS', cifers);
      //console.log('FINISH GENERATE ONE NUMBER', final_number);


      /*if (!breaks && !f_num && !isNaN(final_number)  && final_number !== false) {
        return final_number;
      } else if ((!breaks && f_num && !isNaN(final_number) && final_number !== false) && (cifers[f_axis] === f_num)) {
        return final_number;
      }*/

      //return this.returnAllowedNumberByTable(sum);

    },

  },
  mounted() {
    //this.colors = _.shuffle(this.colors);
  }
};